import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.095 18.32c3.131 2.43 7.69 2.209 10.562-.663 2.872-2.872 3.093-7.431.663-10.562L7.095 18.32zM5.68 16.905L16.906 5.68c-3.132-2.43-7.69-2.209-10.563.663-2.872 2.872-3.093 7.43-.663 10.562zM4.93 4.93c3.889-3.89 10.253-3.89 14.142 0 3.89 3.889 3.89 10.253 0 14.142-3.889 3.89-10.253 3.89-14.142 0-3.89-3.89-3.89-10.253 0-14.142z"
      fill="currentColor"
    />
  </svg>
);
